import React from 'react';
import { Input } from 'antd';
import { F9430 } from '../../../services/pw9233Api';

interface MasterInfoProps {
  formData: Partial<F9430>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: <K extends keyof F9430>(key: K) => F9430[K] | string;
  setField: <K extends keyof F9430>(key: K, value: F9430[K]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
  getFieldError?: (field: string) => string | undefined;
  mode: 'browse' | 'add' | 'edit';
}

const FieldError: React.FC<{ error?: string }> = ({ error }) =>
  error ? <span style={{ color: '#ff4d4f', fontSize: 11, marginLeft: 6, fontWeight: 'normal' }}>{error}</span> : null;

const MasterInfo: React.FC<MasterInfoProps> = ({
  formData, names, isEditing,
  getField, setField, resolveSingleName, getFieldError, mode,
}) => {
  const E = (field: string) => <FieldError error={getFieldError?.(field)} />;

  const isAddMode = mode === 'add';

  return (
    <div className="pw9233-master-info">
      <div className="pw9233-header-row">
        <div className="pw9233-field-group">
          <label className="required">員工代號{E('F9430_01')}</label>
          <div className="pw9233-lookup-field">
            <Input
              style={{ width: 120 }}
              maxLength={8}
              disabled={!isAddMode}
              value={getField('f9430_01') as string}
              onChange={e => setField('f9430_01', e.target.value)}
              onBlur={() => resolveSingleName('employee', 'employee', getField('f9430_01') as string)}
              placeholder="員工代號"
            />
            <span className="pw9233-lookup-name">{names.employee || '--'}</span>
          </div>
        </div>

        <div className="pw9233-field-group">
          <label className="required">年月{E('F9430_02')}</label>
          <Input
            style={{ width: 100 }}
            maxLength={6}
            disabled={!isAddMode}
            value={getField('f9430_02') as string}
            onChange={e => setField('f9430_02', e.target.value)}
            placeholder="YYYYMM"
          />
        </div>

        <div className="pw9233-field-group">
          <label>備用說明{E('F9430_11')}</label>
          <Input
            style={{ width: 240 }}
            maxLength={30}
            disabled={!isEditing}
            value={getField('f9430_11') as string}
            onChange={e => setField('f9430_11', e.target.value)}
            placeholder="備用說明"
          />
        </div>

        <div className="pw9233-field-group">
          <label>部門名稱</label>
          <Input
            style={{ width: 160 }}
            readOnly
            value={(formData as any).f106_11 || ''}
            placeholder="部門名稱"
          />
        </div>

        <div className="pw9233-field-group">
          <label>明細筆數</label>
          <Input
            style={{ width: 60 }}
            readOnly
            value={formData.f9430_14 ?? 0}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(MasterInfo);
